export const SITE_URL = "https://johnmendez.tech";
